import React from "react";
import TvTillbehorCard from "../components/TvTillbehorCard";

export default function TvEquipment({ isVisible, network }) {
  return (
    <div className={isVisible ? "tel-pt-tv-equipment" : "tel-pt-tv-equipment not-visible"}>
      <p className="tel-pt-view-description">Behöver du en kortläsare eller andra tillbehör för din TV-installation?</p>

      {network.tv_tillbehor &&
        network.tv_tillbehor.map((tvTillbehor: any) => {
          if (tvTillbehor) return <TvTillbehorCard data={tvTillbehor} />;

          return null;
        })}
      {!network.tv_tillbehor && <h2 className="tel-p-form__no-product-text">Inga tillgängliga tv tillbehör</h2>}
    </div>
  );
}
